import i18n from "../../../../../constants/i18n";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import { TEt3PickerSingleValue } from "../../../../../TypesNEW";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Picker from "../../../../../core/et3-input/et3-picker";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";

const PaidUsersPicker = withLiteObserverAndTheme(
  ({ showCount }: { showCount: boolean }) => {
    return (
      <Et3Picker
        label={i18n.get("PAID_USERS")}
        options={getKhattabatMatchingStore().getUsersIdsOptions(showCount)}
        value={getKhattabatMatchingStore().getCurrentPaidUserPickerValue()}
        onChoose={(value: TEt3PickerSingleValue) => {
          getKhattabatMatchingStore().setCurrentUserInformation(value);
          getKhattabat101MGeneralStore().setClientConversations([]);
        }}
        onEnter={() => {}}
        isMultiple={false}
        style={{}}
        onClick={() => {}}
        containerStyle={{}}
      />
    );
  }
);

export default PaidUsersPicker;
